import React from 'react';
import PropTypes from 'prop-types';

const Overlay = ({ children, Style = {} }) => (
  <div className={Style.overlayContainer}>{children}</div>
);

export default Overlay;

Overlay.propTypes = {
  children: PropTypes.node,
  Style: PropTypes.shape({}),
};
